import React, { useEffect, useState } from "react";
import heroImg from "../assets/pricing.png";

export default function Pricing() {
  /* ================= SCROLL REVEAL ================= */
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("active");
        });
      },
      { threshold: 0.15 }
    );
    elements.forEach((el) => observer.observe(el));
  }, []);

  /* ================= DATA ================= */
  const stores = ["Delhi", "Gurugram", "Noida", "Faridabad", "Ghaziabad"];
  const services = ["Dry Cleaning", "Steam Press Only", "Starch", "Delivery Charge", "On Hanger", "Laundry", "Leather Care", "Wash and Fold", "Wash N Iron"];
  const tabs = ["Men", "Women", "Kids", "Institutional", "Household", "Others"];
  const pricingData = {
    "Dry Cleaning": {
    Men: [
  { item: "T Shirt", code: "TF", price: "₹99" },
  { item: "Jeans", code: "JE", price: "₹99" },
  { item: "Longcoat", code: "LC", price: "₹380" },
  { item: "Leather Jacket", code: "LJ", price: "₹700" },
  { item: "Pants", code: "PA", price: "₹99" },
  { item: "Shirt", code: "SH", price: "₹99" },
  { item: "Coat", code: "CT", price: "₹250" },
  { item: "Jacket Half", code: "JH", price: "₹180" },
  { item: "Jacket", code: "JK", price: "₹355" },
  { item: "Blazer", code: "BZ", price: "₹250" },
  { item: "Suit 2 Pcs", code: "S2", price: "₹350" },
  { item: "Suit 3 Pcs", code: "S3", price: "₹450" },
  { item: "Overcoat", code: "OC", price: "₹430" },
  { item: "Safari Suit", code: "SS", price: "₹250" },
  { item: "Waist Coat", code: "WC", price: "₹100" },
  { item: "Kurta", code: "KU", price: "₹145" },
  { item: "Achkan", code: "AK", price: "₹399" },
  { item: "Sherwani", code: "SW", price: "₹249" },
  { item: "Dhoti Kurta", code: "DK", price: "₹244" },
  { item: "Kurta Pyajama", code: "KP", price: "₹244" },
  { item: "Pathani Suit", code: "PS", price: "₹349" },
  { item: "Sweat Shirt", code: "ST", price: "₹180" },
  { item: "Sports Jacket", code: "SJ", price: "₹355" },
  { item: "Shorts", code: "SO", price: "₹80" },
  { item: "Pyjama", code: "PY", price: "₹99" },
  { item: "Sweat Pants", code: "SP", price: "₹120" },
  { item: "Track Pant", code: "TP", price: "₹99" },
  { item: "Capri", code: "CP", price: "₹99" },
  { item: "Tuxedo", code: "TX", price: "₹508" },
  { item: "Pullover", code: "PL", price: "₹199" },
  { item: "Sweater Half", code: "SF", price: "₹179" },
  { item: "Track Suit", code: "TS", price: "₹299" },
  { item: "Undershirt", code: "US", price: "₹99" },
  { item: "Bath Robe", code: "BR", price: "₹249" },
  { item: "Tie", code: "TI", price: "₹30" },
  { item: "Swimming Costume", code: "SC", price: "₹199" }
],

     Women: [
  { item: "T Shirt", code: "T", price: "₹99" },
  { item: "Shirt", code: "Shi", price: "₹99" },
  { item: "Ladies Suit Ethnic", code: "LSE", price: "₹314" },
  { item: "Kameez", code: "KA", price: "₹99" },
  { item: "Salwar", code: "SAL", price: "₹99" },
  { item: "Lehnga", code: "L", price: "₹359" },
  { item: "Choli", code: "CH", price: "₹99" },
  { item: "Saree", code: "SA", price: "₹179" },
  { item: "Blouse", code: "B", price: "₹70" },
  { item: "Jeans", code: "JeF", price: "₹99" },
  { item: "Pants", code: "PF", price: "₹99" },
  { item: "Capri", code: "Cap", price: "₹99" },
  { item: "Track Pant", code: "Tpa", price: "₹99" },
  { item: "Dress", code: "D", price: "₹149" },
  { item: "Gown", code: "G", price: "₹349" },
  { item: "Dress long", code: "DL", price: "₹299" },
  { item: "Slacks", code: "SLA", price: "₹99" },
  { item: "Skirt", code: "SKI", price: "₹179" },
  { item: "Scarf", code: "Sca", price: "₹99" },
  { item: "Wedding Dress", code: "WD", price: "₹349" },
  { item: "Jacket", code: "JL", price: "₹355" },
  { item: "Jacket Half", code: "JHL", price: "₹259" },
  { item: "Sport Jacket", code: "Sja", price: "₹355" },
  { item: "Shawl", code: "SHA", price: "₹170" },
  { item: "Pullover", code: "POL", price: "₹199" },
  { item: "Cardigan", code: "Card", price: "₹199" },
  { item: "Coat", code: "CL", price: "₹250" },
  { item: "Long Coat", code: "LCF", price: "₹380" },
  { item: "Over Coat", code: "OCK", price: "₹450" },
  { item: "Ladies Suit Western", code: "LSW", price: "₹349" },
  { item: "Jumper", code: "JU", price: "₹129" },
  { item: "Dangree", code: "DAN", price: "₹199" },
  { item: "Stocking", code: "sto", price: "₹99" },
  { item: "Swimming Costume", code: "SCO", price: "₹179" },
  { item: "Bikini", code: "BI", price: "₹99" },
  { item: "Brassieres", code: "Bra", price: "₹49" }
],
Kids: [
  { item: "Shirt", code: "SK", price: "₹69" },
  { item: "Jeans", code: "JeK", price: "₹69" },
  { item: "Pants", code: "PK", price: "₹69" },
  { item: "Kurta", code: "KK", price: "₹79" },
  { item: "Pyjama", code: "PY", price: "₹69" },
  { item: "Kurta Pyajama", code: "KPK", price: "₹149" },
  { item: "Track Pant", code: "tpk", price: "₹69" },
  { item: "Sport Jacket", code: "Sjac", price: "₹179" },
  { item: "Sherwani", code: "SHW", price: "₹159" },
  { item: "Pullover", code: "POK", price: "₹129" },
  { item: "Jacket", code: "JK", price: "₹220" },
  { item: "Suit 2 Pcs", code: "S2K", price: "₹208" },
  { item: "Suit 3 Pcs", code: "S3k", price: "₹288" },
  { item: "T Shirt", code: "TK", price: "₹69" },
  { item: "Capri", code: "capr", price: "₹69" },
  { item: "Shorts", code: "SHK", price: "₹49" },
  { item: "Dress long", code: "DRL", price: "₹199" },
  { item: "Dress", code: "Dr", price: "₹149" },
  { item: "Girl Suit Ethnic", code: "LSK", price: "₹249" },
  { item: "Gown", code: "GO", price: "₹179" },
  { item: "Coat", code: "CK", price: "₹149" },
  { item: "Dangree", code: "DAK", price: "₹149" },
  { item: "Lehnga", code: "LK", price: "₹249" },
  { item: "Choli", code: "CHO", price: "₹69" },
  { item: "Long Coat", code: "LCK", price: "₹199" },
  { item: "Jacket Half", code: "JHK", price: "₹149" },
  { item: "Sweat Shirt", code: "ssh", price: "₹129" },
  { item: "Waist Coat", code: "wck", price: "₹99" },
  { item: "Sweater Half", code: "SWH", price: "₹119" },
  { item: "Pathani Suit", code: "PSK", price: "₹299" },
  { item: "Achkan", code: "A", price: "₹199" },
  { item: "Swimming Costume", code: "SCH", price: "₹139" },
  { item: "Skirt", code: "SHKT", price: "₹69" },
  { item: "Tie", code: "TieK", price: "₹29" }
],

    Institutional: [
  { item: "Bed Sheet Double", code: "BSDD", price: "₹199" },
  { item: "Bed Sheet Single", code: "BSSS", price: "₹119" },
  { item: "Towel", code: "TO", price: "₹119" },
  { item: "Bed Spread Double", code: "BSPD", price: "₹249" },
  { item: "Bed Spread Single", code: "BSPSI", price: "₹199" },
  { item: "Blanket Double", code: "BDH", price: "₹449" },
  { item: "Blanket Single", code: "BSH", price: "₹349" },
  { item: "Quilt Double", code: "QD", price: "₹449" },
  { item: "Quilt Single", code: "QS", price: "₹349" },
  { item: "Carpet ( SQ FT )", code: "CAR", price: "₹40" },
  { item: "Chair Covers", code: "CHC", price: "₹149" },
  { item: "Curtain", code: "Cur", price: "₹229" },
  { item: "Cushion Covers", code: "CC", price: "₹59" },
  { item: "Duvet", code: "DU", price: "₹349" },
  { item: "Foot Mats", code: "FM", price: "₹140" },
  { item: "Hand Towel", code: "HT", price: "₹69" },
  { item: "Pillow Covers", code: "PC", price: "₹69" },
  { item: "Table Cloth", code: "TC", price: "₹149" },
  { item: "Police Suit", code: "PSU", price: "₹199" },
  { item: "Pool Towel", code: "PT", price: "₹149" }
],
Household: [
  { item: "Bag", code: "bag", price: "₹275" },
  { item: "Cushion Covers", code: "CUC", price: "₹59" },
  { item: "Hand Towel", code: "HTO", price: "₹69" },
  { item: "Handkerchief", code: "Ha", price: "₹39" },
  { item: "Chair Covers", code: "CCO", price: "₹149" },
  { item: "Duvet", code: "DUV", price: "₹349" },
  { item: "Foot Mats", code: "FMA", price: "₹140" },
  { item: "Gloves", code: "GLO", price: "₹129" },
  { item: "Socks", code: "SO", price: "₹59" },
  { item: "Table Cloth", code: "TCH", price: "₹149" },
  { item: "Towel", code: "Tow", price: "₹149" }
],


      Others: [
  { item: "Rain Coat", code: "RC", price: "₹299" },
  { item: "Hat", code: "H", price: "₹99" },
  { item: "Belt", code: "BE", price: "₹99" },
  { item: "Car Seatcover", code: "CS", price: "₹149" },
  { item: "Stuff Toy", code: "ST", price: "₹349" },
  { item: "Sports Shoes", code: "SPO", price: "₹300" },
  { item: "Leather Shoes", code: "LS", price: "₹910" }
]
    },
    "Steam Press Only": {
      Men: [
  { item: "T Shirt", code: "TF", price: "₹50" },
  { item: "Jeans", code: "Je", price: "₹50" },
  { item: "Longcoat", code: "LC", price: "₹200" },
  { item: "Leather Jacket", code: "LJ", price: "₹0" },
  { item: "Pants", code: "P", price: "₹50" },
  { item: "Shirt", code: "S", price: "₹50" },
  { item: "Coat", code: "C", price: "₹150" },
  { item: "Jacket Half", code: "JH", price: "₹0" },
  { item: "Jacket", code: "J", price: "₹0" },
  { item: "Blazer", code: "BL", price: "₹130" },
  { item: "Suit 2 Pcs", code: "S2", price: "₹200" },
  { item: "Suit 3 Pcs", code: "S3", price: "₹250" },
  { item: "Overcoat", code: "OC", price: "₹300" },
  { item: "Safari Suit", code: "SS", price: "₹0" },
  { item: "Waist Coat", code: "WC", price: "₹50" },
  { item: "Kurta", code: "K", price: "₹60" },
  { item: "Achkan", code: "AC", price: "₹180" },
  { item: "Sherwani", code: "SHE", price: "₹200" },
  { item: "Dhoti Kurta", code: "DK", price: "₹0" },
  { item: "Kurta Pyajama", code: "KP", price: "₹110" },
  { item: "Pathani Suit", code: "PS", price: "₹0" },
  { item: "Sweat Shirt", code: "SW", price: "₹60" },
  { item: "Sports Jacket", code: "SJ", price: "₹0" },
  { item: "Shorts", code: "SH", price: "₹0" },
  { item: "Pyjama", code: "PYK", price: "₹50" },
  { item: "Sweat Pants", code: "SP", price: "₹60" },
  { item: "Track Pant", code: "TP", price: "₹50" },
  { item: "Capri", code: "CA", price: "₹50" },
  { item: "Tuxedo", code: "TUX", price: "₹260" },
  { item: "Pullover", code: "PO", price: "₹60" },
  { item: "Sweater Half", code: "SWS", price: "₹60" },
  { item: "Track Suit", code: "TS", price: "₹0" },
  { item: "Undershirt", code: "Un", price: "₹0" },
  { item: "Bath Robe", code: "BR", price: "₹0" },
  { item: "Tie", code: "TIE", price: "₹0" },
  { item: "Swimming Costume", code: "SC", price: "₹0" },
  { item: "Laundry Garment", code: "lgcv", price: "₹0" }
],

      Women: [
  { item: "T Shirt", code: "T", price: "₹50" },
  { item: "Shirt", code: "Shi", price: "₹50" },
  { item: "Ladies Suit Ethnic", code: "LSE", price: "₹200" },
  { item: "Kameez", code: "KA", price: "₹0" },
  { item: "Salwar", code: "SAL", price: "₹50" },
  { item: "Lehnga", code: "L", price: "₹250" },
  { item: "Choli", code: "CH", price: "₹0" },
  { item: "Saree", code: "SA", price: "₹100" },
  { item: "Blouse", code: "B", price: "₹40" },
  { item: "Jeans", code: "JeF", price: "₹50" },
  { item: "Pants", code: "PF", price: "₹50" },
  { item: "Capri", code: "Cap", price: "₹50" },
  { item: "Track Pant", code: "Tpa", price: "₹0" },
  { item: "Dress", code: "D", price: "₹100" },
  { item: "Gown", code: "G", price: "₹250" },
  { item: "Dress long", code: "DL", price: "₹140" },
  { item: "Slacks", code: "SLA", price: "₹50" },
  { item: "Skirt", code: "SKI", price: "₹100" },
  { item: "Scarf", code: "Sca", price: "₹50" },
  { item: "Wedding Dress", code: "WD", price: "₹180" },
  { item: "Jacket", code: "JL", price: "₹0" },
  { item: "Jacket Half", code: "JHL", price: "₹0" },
  { item: "Sport Jacket", code: "Sja", price: "₹0" },
  { item: "Shawl", code: "SHA", price: "₹60" },
  { item: "Pullover", code: "POL", price: "₹0" },
  { item: "Cardigan", code: "Card", price: "₹0" },
  { item: "Coat", code: "CL", price: "₹0" },
  { item: "Long Coat", code: "LCF", price: "₹200" },
  { item: "Over Coat", code: "OCK", price: "₹280" },
  { item: "Ladies Suit Western", code: "LSW", price: "₹200" },
  { item: "Jumper", code: "JU", price: "₹0" },
  { item: "Dangree", code: "DAN", price: "₹0" },
  { item: "Stocking", code: "sto", price: "₹0" },
  { item: "Swimming Costume", code: "SCO", price: "₹0" },
  { item: "Bikini", code: "BI", price: "₹0" },
  { item: "Brassieres", code: "Bra", price: "₹0" }
],
Kids: [
  { item: "Shirt", code: "SK", price: "₹40" },
  { item: "Jeans", code: "JeK", price: "₹40" },
  { item: "Pants", code: "PK", price: "₹40" },
  { item: "Kurta", code: "KK", price: "₹50" },
  { item: "Pyjama", code: "PY", price: "₹50" },
  { item: "Kurta Pyajama", code: "KPK", price: "₹90" },
  { item: "Track Pant", code: "tpk", price: "₹0" },
  { item: "Sport Jacket", code: "Sjac", price: "₹0" },
  { item: "Sherwani", code: "SHW", price: "₹0" },
  { item: "Pullover", code: "POK", price: "₹0" },
  { item: "Jacket", code: "JK", price: "₹0" },
  { item: "Suit 2 Pcs", code: "S2K", price: "₹100" },
  { item: "Suit 3 Pcs", code: "S3k", price: "₹150" },
  { item: "T Shirt", code: "TK", price: "₹50" },
  { item: "Capri", code: "capr", price: "₹0" },
  { item: "Shorts", code: "SHK", price: "₹0" },
  { item: "Dress long", code: "DRL", price: "₹130" },
  { item: "Dress", code: "Dr", price: "₹100" },
  { item: "Girl Suit Ethnic", code: "LSK", price: "₹0" },
  { item: "Gown", code: "GO", price: "₹100" },
  { item: "Coat", code: "CK", price: "₹80" },
  { item: "Dangree", code: "DAK", price: "₹0" },
  { item: "Lehnga", code: "LK", price: "₹130" },
  { item: "Choli", code: "CHO", price: "₹0" },
  { item: "Long Coat", code: "LCK", price: "₹100" },
  { item: "Jacket Half", code: "JHK", price: "₹0" },
  { item: "Sweat Shirt", code: "ssh", price: "₹0" },
  { item: "Waist Coat", code: "wck", price: "₹0" },
  { item: "Sweater Half", code: "SWH", price: "₹0" },
  { item: "Pathani Suit", code: "PSK", price: "₹0" },
  { item: "Achkan", code: "A", price: "₹0" },
  { item: "Swimming Costume", code: "SCH", price: "₹0" },
  { item: "Skirt", code: "SHKT", price: "₹0" },
  { item: "Tie", code: "TieK", price: "₹0" }
],

      Institutional: [
  { item: "Bed Sheet Double", code: "BSDD", price: "₹0" },
  { item: "Bed Sheet Single", code: "BSSS", price: "₹0" },
  { item: "Towel", code: "TO", price: "₹0" },
  { item: "Bed Spread Double", code: "BSPD", price: "₹130" },
  { item: "Bed Spread Single", code: "BSPSI", price: "₹100" },
  { item: "Blanket Double", code: "BDH", price: "₹0" },
  { item: "Blanket Single", code: "BSH", price: "₹0" },
  { item: "Quilt Double", code: "QD", price: "₹0" },
  { item: "Quilt Single", code: "QS", price: "₹0" },
  { item: "Carpet ( SQ FT )", code: "CAR", price: "₹0" },
  { item: "Chair Covers", code: "CHC", price: "₹0" },
  { item: "Curtain", code: "Cur", price: "₹0" },
  { item: "Cushion Covers", code: "CC", price: "₹0" },
  { item: "Duvet", code: "DU", price: "₹0" },
  { item: "Foot Mats", code: "FM", price: "₹0" },
  { item: "Hand Towel", code: "HT", price: "₹0" },
  { item: "Pillow Covers", code: "PC", price: "₹0" },
  { item: "Table Cloth", code: "TC", price: "₹0" },
  { item: "Police Suit", code: "PSU", price: "₹100" },
  { item: "Pool Towel", code: "PT", price: "₹0" }
],
Household: [
  { item: "Bag", code: "bag", price: "₹0" },
  { item: "Cushion Covers", code: "CUC", price: "₹0" },
  { item: "Hand Towel", code: "HTO", price: "₹0" },
  { item: "Handkerchief", code: "Ha", price: "₹0" },
  { item: "Chair Covers", code: "CCO", price: "₹0" },
  { item: "Duvet", code: "DUV", price: "₹0" },
  { item: "Foot Mats", code: "FMA", price: "₹0" },
  { item: "Gloves", code: "GLO", price: "₹0" },
  { item: "Socks", code: "SO", price: "₹0" },
  { item: "Table Cloth", code: "TCH", price: "₹0" },
  { item: "Towel", code: "Tow", price: "₹0" }
],

     Others: [
  { item: "Rain Coat", code: "RC", price: "₹0" },
  { item: "Hat", code: "H", price: "₹0" },
  { item: "Belt", code: "BE", price: "₹0" },
  { item: "Car Seatcover", code: "CS", price: "₹0" },
  { item: "Stuff Toy", code: "ST", price: "₹0" },
  { item: "Sports Shoes", code: "SPO", price: "₹0" },
  { item: "Leather Shoes", code: "LS", price: "₹0" }
],

    },
    Starch: {
      Men: [
  { item: "T Shirt", code: "TF", price: "₹60" },
  { item: "Jeans", code: "Je", price: "₹60" },
  { item: "Longcoat", code: "LC", price: "₹0" },
  { item: "Leather Jacket", code: "LJ", price: "₹0" },
  { item: "Pants", code: "P", price: "₹60" },
  { item: "Shirt", code: "S", price: "₹60" },
  { item: "Coat", code: "C", price: "₹0" },
  { item: "Jacket Half", code: "JH", price: "₹0" },
  { item: "Jacket", code: "J", price: "₹0" },
  { item: "Blazer", code: "BL", price: "₹0" },
  { item: "Suit 2 Pcs", code: "S2", price: "₹0" },
  { item: "Suit 3 Pcs", code: "S3", price: "₹0" },
  { item: "Overcoat", code: "OC", price: "₹0" },
  { item: "Safari Suit", code: "SS", price: "₹0" },
  { item: "Waist Coat", code: "WC", price: "₹0" },
  { item: "Kurta", code: "K", price: "₹60" },
  { item: "Achkan", code: "AC", price: "₹0" },
  { item: "Sherwani", code: "SHE", price: "₹0" },
  { item: "Dhoti Kurta", code: "DK", price: "₹60" },
  { item: "Kurta Pyajama", code: "KP", price: "₹120" },
  { item: "Pathani Suit", code: "PS", price: "₹0" },
  { item: "Sweat Shirt", code: "SW", price: "₹0" },
  { item: "Sports Jacket", code: "SJ", price: "₹0" },
  { item: "Shorts", code: "SH", price: "₹0" },
  { item: "Pyjama", code: "PYK", price: "₹0" },
  { item: "Sweat Pants", code: "SP", price: "₹0" },
  { item: "Track Pant", code: "TP", price: "₹0" },
  { item: "Capri", code: "CA", price: "₹0" },
  { item: "Tuxedo", code: "TUX", price: "₹0" },
  { item: "Pullover", code: "PO", price: "₹0" },
  { item: "Sweater Half", code: "SWS", price: "₹0" },
  { item: "Track Suit", code: "TS", price: "₹0" },
  { item: "Undershirt", code: "Un", price: "₹0" },
  { item: "Bath Robe", code: "BR", price: "₹0" },
  { item: "Tie", code: "TIE", price: "₹0" },
  { item: "Swimming Costume", code: "SC", price: "₹0" },
  { item: "Laundry Garment", code: "lgcv", price: "₹0" }
],

     StarchWomen: [
  { item: "T Shirt", code: "T", price: "₹0" },
  { item: "Shirt", code: "Shi", price: "₹60" },
  { item: "Ladies Suit Ethnic", code: "LSE", price: "₹60" },
  { item: "Kameez", code: "KA", price: "₹0" },
  { item: "Salwar", code: "SAL", price: "₹0" },
  { item: "Lehnga", code: "L", price: "₹0" },
  { item: "Choli", code: "CH", price: "₹0" },
  { item: "Saree", code: "SA", price: "₹120" },
  { item: "Blouse", code: "B", price: "₹40" },
  { item: "Jeans", code: "JeF", price: "₹0" },
  { item: "Pants", code: "PF", price: "₹60" },
  { item: "Capri", code: "Cap", price: "₹0" },
  { item: "Track Pant", code: "Tpa", price: "₹0" },
  { item: "Dress", code: "D", price: "₹0" },
  { item: "Gown", code: "G", price: "₹0" },
  { item: "Dress long", code: "DL", price: "₹0" },
  { item: "Slacks", code: "SLA", price: "₹0" },
  { item: "Skirt", code: "SKI", price: "₹0" },
  { item: "Scarf", code: "Sca", price: "₹0" },
  { item: "Wedding Dress", code: "WD", price: "₹0" },
  { item: "Jacket", code: "JL", price: "₹0" },
  { item: "Jacket Half", code: "JHL", price: "₹0" },
  { item: "Sport Jacket", code: "Sja", price: "₹0" },
  { item: "Shawl", code: "SHA", price: "₹0" },
  { item: "Pullover", code: "POL", price: "₹0" },
  { item: "Cardigan", code: "Card", price: "₹0" },
  { item: "Coat", code: "CL", price: "₹0" },
  { item: "Long Coat", code: "LCF", price: "₹0" },
  { item: "Over Coat", code: "OCK", price: "₹0" },
  { item: "Ladies Suit Western", code: "LSW", price: "₹0" },
  { item: "Jumper", code: "JU", price: "₹0" },
  { item: "Dangree", code: "DAN", price: "₹0" },
  { item: "Stocking", code: "sto", price: "₹0" },
  { item: "Swimming Costume", code: "SCO", price: "₹0" },
  { item: "Bikini", code: "BI", price: "₹0" },
  { item: "Brassieres", code: "Bra", price: "₹0" }
],
Kids: [
  { item: "Shirt", code: "SK", price: "₹0" },
  { item: "Jeans", code: "JeK", price: "₹0" },
  { item: "Pants", code: "PK", price: "₹0" },
  { item: "Kurta", code: "KK", price: "₹0" },
  { item: "Pyjama", code: "PY", price: "₹0" },
  { item: "Kurta Pyajama", code: "KPK", price: "₹0" },
  { item: "Track Pant", code: "tpk", price: "₹0" },
  { item: "Sport Jacket", code: "Sjac", price: "₹0" },
  { item: "Sherwani", code: "SHW", price: "₹0" },
  { item: "Pullover", code: "POK", price: "₹0" },
  { item: "Jacket", code: "JK", price: "₹0" },
  { item: "Suit 2 Pcs", code: "S2K", price: "₹0" },
  { item: "Suit 3 Pcs", code: "S3k", price: "₹0" },
  { item: "T Shirt", code: "TK", price: "₹0" },
  { item: "Capri", code: "capr", price: "₹0" },
  { item: "Shorts", code: "SHK", price: "₹0" },
  { item: "Dress long", code: "DRL", price: "₹0" },
  { item: "Dress", code: "Dr", price: "₹0" },
  { item: "Girl Suit Ethnic", code: "LSK", price: "₹0" },
  { item: "Gown", code: "GO", price: "₹0" },
  { item: "Coat", code: "CK", price: "₹0" },
  { item: "Dangree", code: "DAK", price: "₹0" },
  { item: "Lehnga", code: "LK", price: "₹0" },
  { item: "Choli", code: "CHO", price: "₹0" },
  { item: "Long Coat", code: "LCK", price: "₹0" },
  { item: "Jacket Half", code: "JHK", price: "₹0" },
  { item: "Sweat Shirt", code: "ssh", price: "₹0" },
  { item: "Waist Coat", code: "wck", price: "₹0" },
  { item: "Sweater Half", code: "SWH", price: "₹0" },
  { item: "Pathani Suit", code: "PSK", price: "₹0" },
  { item: "Achkan", code: "A", price: "₹0" },
  { item: "Swimming Costume", code: "SCH", price: "₹0" },
  { item: "Skirt", code: "SHKT", price: "₹0" },
  { item: "Tie", code: "TieK", price: "₹0" }
],

      Institutional: [
  { item: "Bed Sheet Double", code: "BSDD", price: "₹0" },
  { item: "Bed Sheet Single", code: "BSSS", price: "₹0" },
  { item: "Towel", code: "TO", price: "₹0" },
  { item: "Bed Spread Double", code: "BSPD", price: "₹0" },
  { item: "Bed Spread Single", code: "BSPSI", price: "₹0" },
  { item: "Blanket Double", code: "BDH", price: "₹0" },
  { item: "Blanket Single", code: "BSH", price: "₹0" },
  { item: "Quilt Double", code: "QD", price: "₹0" },
  { item: "Quilt Single", code: "QS", price: "₹0" },
  { item: "Carpet ( SQ FT )", code: "CAR", price: "₹0" },
  { item: "Chair Covers", code: "CHC", price: "₹0" },
  { item: "Curtain", code: "Cur", price: "₹0" },
  { item: "Cushion Covers", code: "CC", price: "₹0" },
  { item: "Duvet", code: "DU", price: "₹0" },
  { item: "Foot Mats", code: "FM", price: "₹0" },
  { item: "Hand Towel", code: "HT", price: "₹0" },
  { item: "Pillow Covers", code: "PC", price: "₹0" },
  { item: "Table Cloth", code: "TC", price: "₹0" },
  { item: "Police Suit", code: "PSU", price: "₹0" },
  { item: "Pool Towel", code: "PT", price: "₹0" }
],
Household: [
  { item: "Bag", code: "bag", price: "₹0" },
  { item: "Cushion Covers", code: "CUC", price: "₹0" },
  { item: "Hand Towel", code: "HTO", price: "₹0" },
  { item: "Handkerchief", code: "Ha", price: "₹0" },
  { item: "Chair Covers", code: "CCO", price: "₹0" },
  { item: "Duvet", code: "DUV", price: "₹0" },
  { item: "Foot Mats", code: "FMA", price: "₹0" },
  { item: "Gloves", code: "GLO", price: "₹0" },
  { item: "Socks", code: "SO", price: "₹0" },
  { item: "Table Cloth", code: "TCH", price: "₹0" },
  { item: "Towel", code: "Tow", price: "₹0" }
],


     Others: [
  { item: "Rain Coat", code: "RC", price: "₹0" },
  { item: "Hat", code: "H", price: "₹0" },
  { item: "Belt", code: "BE", price: "₹0" },
  { item: "Car Seatcover", code: "CS", price: "₹0" },
  { item: "Stuff Toy", code: "ST", price: "₹0" },
  { item: "Sports Shoes", code: "SPO", price: "₹0" },
  { item: "Leather Shoes", code: "LS", price: "₹0" }
],

    }
  };

  /* ================= STATE ================= */
  const [selectedStore, setSelectedStore] = useState(stores[0]);
  const [selectedService, setSelectedService] = useState(services[0]);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  const currentPricing =
    pricingData[selectedService]?.[selectedTab] || [];

  /* ================= JSX ================= */
  return (
    <>
      <style>{`
        * { box-sizing: border-box; }
        body {
          margin: 0;
          font-family: "Segoe UI", sans-serif;
          background: #f9fafc;
        }

        /* HERO */
        .hero {
          width: 100%;
          height: 50vh;
        }
        .hero img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
 @media (max-width: 768px) {
  .hero {
    height: auto;
  }

  .hero img {
    height: auto;
    object-fit: contain;
  }
}
        /* CONTAINER */
        .pricing-container {
          max-width: 1200px;
          margin: auto;
          padding: 40px 20px 60px;
        }

        /* HEADER */
        .store-select {
          margin: 20px 0;
        }

        /* LAYOUT */
        .content {
          display: flex;
          gap: 30px;
        }

        /* SIDEBAR */
        .sidebar {
          width: 220px;
          background: #fff;
          padding: 20px;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,.1);
        }
        .sidebar ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .sidebar li {
          padding: 12px;
          margin-bottom: 8px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          color: #555;
        }
        .sidebar li.active {
          background: #1b7a9f;
          color: #fff;
        }

        /* MAIN */
        .main-content {
          flex: 1;
          background: #fff;
          padding: 25px;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0,0,0,.08);
        }

        /* TABS */
        .tabs {
          display: flex;
          gap: 16px;
          border-bottom: 2px solid #e0e6f0;
          margin-bottom: 20px;
        }
        .tab {
          background: none;
          border: none;
          padding: 10px 18px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          color: #555;
          border-bottom: 3px solid transparent;
        }
        .tab.active {
          color: #1b7a9f;
          border-bottom: 3px solid #1b7a9f;
        }
/* ================= TABS – RESPONSIVE ================= */
@media (max-width: 768px) {
  .tabs {
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
  }

  .tab {
    padding: 8px 14px;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .tabs {
    justify-content: flex-start;
  }

  .tab {
    padding: 6px 10px;
    font-size: 0.85rem;
  }
}

        /* TABLE */
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          padding: 14px;
          border-bottom: 1px solid #ddd;
        }
        th {
          background: #eef3ff;
          color: #1b7a9f;
        }
        th:nth-child(1), td:nth-child(1) { text-align: left; }
        th:nth-child(2), td:nth-child(2) { text-align: center; }
        th:nth-child(3), td:nth-child(3) { text-align: right; }

        td.price {
          font-weight: 700;
          color: #1b7a9fff;
        }

        .empty {
          padding: 25px;
          text-align: center;
          color: #777;
          font-weight: 600;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .content {
            flex-direction: column;
          }
          .sidebar {
            width: 100%;
          }
        }
      `}</style>

      {/* HERO */}
      <div className="hero reveal">
        <img src={heroImg} alt="Pricing" />
      </div>

      {/* CONTENT */}
      <div className="pricing-container reveal">
        <div className="store-select">
          <label>Select Location: </label>
          <select
            value={selectedStore}
            onChange={(e) => setSelectedStore(e.target.value)}
          >
            {stores.map((s) => (
              <option key={s}>{s}</option>
            ))}
          </select>
        </div>

        <div className="content">
          {/* SIDEBAR */}
          <div className="sidebar">
            <h3>Services</h3>
            <ul>
              {services.map((s) => (
                <li
                  key={s}
                  className={s === selectedService ? "active" : ""}
                  onClick={() => setSelectedService(s)}
                >
                  {s}
                </li>
              ))}
            </ul>
          </div>

          {/* MAIN */}
          <div className="main-content">
            {/* TABS */}
            <div className="tabs">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`tab ${tab === selectedTab ? "active" : ""}`}
                  onClick={() => setSelectedTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* TABLE */}
            {currentPricing.length ? (
              <table>
                <thead>
                  <tr>
                    <th>Garment</th>
                    <th>Code</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {currentPricing.map(({ item, code, price }) => (
                    <tr key={item}>
                      <td>{item}</td>
                      <td>{code}</td>
                      <td className="price">{price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="empty">
                "Please contact us for detailed pricing information."
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
